import type { ButtonHTMLAttributes, ReactNode } from 'react';

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'danger' | 'ghost' | 'outline' | 'success';
  size?: 'sm' | 'md' | 'lg';
  loading?: boolean;
  children: ReactNode;
}

const variants: Record<string, string> = {
  primary: 'bg-navy-900 text-white hover:bg-navy-800 focus:ring-navy-300',
  secondary: 'bg-navy-100 text-navy-800 hover:bg-navy-200 focus:ring-navy-200',
  danger: 'bg-red-600 text-white hover:bg-red-700 focus:ring-red-200',
  success: 'bg-emerald-600 text-white hover:bg-emerald-700 focus:ring-emerald-200',
  ghost: 'bg-transparent text-navy-700 hover:bg-navy-50 focus:ring-navy-100',
  outline: 'bg-white text-navy-800 border border-navy-200 hover:bg-navy-50 focus:ring-navy-200',
};

const sizes: Record<string, string> = {
  sm: 'px-3 py-1.5 text-xs',
  md: 'px-4 py-2 text-sm',
  lg: 'px-6 py-3 text-sm',
};

export default function Button({
  variant = 'primary',
  size = 'md',
  loading = false,
  children,
  className = '',
  disabled,
  ...rest
}: ButtonProps) {
  return (
    <button
      className={`inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md font-medium transition focus:outline-none focus:ring-2 disabled:opacity-50 disabled:cursor-not-allowed cursor-pointer ${variants[variant]} ${sizes[size]} ${className}`}
      disabled={disabled || loading}
      {...rest}
    >
      {loading && <i className="ri-loader-4-line animate-spin" />}
      {children}
    </button>
  );
}